/**
 *
 * Simple Form implementation for form with only one chart and no special configuration
 *
 */
hrd.charts.ChartOnlyForm = hrd.AbstractFormDashlet.extend({
	RENDERED_EVENT: undefined,
	REFRESH_EVENT: undefined,
	toBeGenerated: true,
	init: function(panel, options) {
		this._super(panel, options);
		this.RENDERED_EVENT = this.settings.prefix + '-rendered';
		this.REFRESH_EVENT = this.settings.prefix + '-refresh';
	},
	emitting: function(events) {
		events.push(this.RENDERED_EVENT);
	},
	listening: function(events) {
		events.push(this.REFRESH_EVENT);
	},
	doDashlet: function() {
		var chartInfo;
		$(this.PANEL_ID).on(this.REFRESH_EVENT, evt => {
			chartInfo = this.$chart.data('chartInfo');
			var force = (chartInfo.loading == 'event-based');
			this.generateChart(force);
		});

		$(this.TAB_ID).on('tab-activated tab-reactivated', evt => {
			if (chartInfo != undefined && chartInfo.loading != 'event-based') {
				this.updateChart(false);
			}
		});
	},
	doForm: function() {
		this.waitingContent();
		this._super();
	},
	formEnhanced: function() {
		this._super();
		this.$chart = $(this.formInstance.getFieldsReferenceByType('chart').get(0));
		if (this.$chart.exists()) {
			// make chart object available
			this.chartObject = this.$chart.data('chartObject');
			var chartInfo = this.$chart.data('chartInfo');
			//if(chartInfo.loading == undefined){
			//$.emit(this.settings.prefix + '-rendered');
			//}
		}
		this.endWaitingContent();
	},
	dashboardHasCompleted: function() {
		if (this.$chart && this.$chart.exists()) {
			var chartInfo = this.$chart.data('chartInfo');
			if (chartInfo != undefined) {
				var force = (chartInfo.loading == 'deferred');
				if (force) {
					$.timeout(500).then(() => this.generateChart(true));
				}
			}
		}
	},
	doResize: function(redraw) {
		this._super(redraw);
		this.generateChart(false);
	},
	refreshChart: function(evt, button, options) {
		options = options || {};
		this.generateChart(false || !!options.force);
	},
	updateChart: function(forceUpdate) {
		forceUpdate = (forceUpdate == undefined) ? (!this.isInsideNotActiveTab()) : forceUpdate;
		if (this.isInsideNotActiveTab()) {
			this.toBeGenerated = true;
		} else {
			if (this.toBeGenerated || forceUpdate) {
				this.generateChart();
			}
			this.toBeGenerated = false;
		}
	},
	generateChart: function(force) {
		force = (force == undefined) ? true : force;
		if (this.$chart && this.$chart.exists()) {
			this.chartObject = this.$chart.data('chartObject');
			if (this.chartObject || force) {
				this.waitingContent();
				this._generateChartInternal();
			}
		}
	},
	destroy: function() {
		if (this.chartObject && this.chartObject.chartInstance) {
			try {
				this.chartObject.chartInstance.destroy();
			} catch (e) {
				console.log("Error Destroying " + this.PANEL_ID);
			}
		}
	},
	_generateChartInternal: function() {
		this.destroy();
		var chartInfo = this.$chart.data('chartInfo');
		if (chartInfo.provider && chartInfo.method) {
			var id = this.$chart.attr('id');
			var extraParams = (typeof chartInfo.extraParams === 'function') ? chartInfo.extraParams.apply(this) : chartInfo.extraParams;
			let options = {
				uriInfo: 'chartData'
			};
			dashboardInstance.invokeProvider(chartInfo.provider, chartInfo.method, extraParams, options).then(function(data) {
				var chartObject = hrd.charts.Factory({ id: '#' + id }, data, chartInfo.extraOptions, chartInfo.customImpl);
				chartObject.settings.container = this;
				chartObject.settings.chartInfo = chartInfo;
				chartObject.postInit();
				// update instance caching
				this.$chart.data('chartObject', chartObject);
				this.chartObject = chartObject;
				//$.emit(this.settings.prefix + '-rendered');
				this.endWaitingContent();
			}.bind(this));
		}
	}
});